import COMPACT_DIALOG_CLASS_NAME from '../../constants/dialog';

const compactDialog = ({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: 12,
  },
  '& .MuiDialogTitle-root': {
    padding: theme.spacing(1),
    borderRadius: '12px 12px 0 0',
    '& .MuiTypography-root': {
      ...theme.typography.medium_1,
      fontWeight: 600,
    },
    '& .MuiIconButton-root': {
      top: '50%',
      right: theme.spacing(1),
      padding: 0,
      transform: 'translateY(-50%)',
    },
  },
});

const MuiDialog = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${COMPACT_DIALOG_CLASS_NAME}`]: compactDialog({ theme }),
    }),
  },
};

export default MuiDialog;
